<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="getList" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="供水流域">
              <j-dict-select-tag
                @change="getList"
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域"
                v-model="queryParam.processId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="设备">
              <j-search-select-tag
                :dict="
                  '`iwt-wf`.dev_list,dev_name,id' +
                    (queryParam.processId ? `,dev_process_id=${queryParam.processId} and del_flag=0` : ', del_flag=0') + 'order by sort asc'
                "
                @change="searchQuery"
                placeholder="请选择设备"
                v-model="queryParam.devId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="告警级别">
              <j-multi-select-tag
                @change="getList"
                dictCode="alert_level"
                placeholder="告警级别"
                type="checkbox"
                v-model="queryParam.alertLevel"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="告警来源">
              <j-multi-select-tag
                @change="getList"
                dictCode="alert_source"
                placeholder="告警级别"
                type="checkbox"
                v-model="queryParam.alertType"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="5" :sm="24" :xl="5">
            <a-form-item label="是否恢复">
              <j-multi-select-tag
                :options="[
                  {
                    label: '已恢复',
                    value: '1'
                  },
                  {
                    label: '未恢复',
                    value: '0'
                  }
                ]"
                @change="getList"
                placeholder="告警级别"
                type="checkbox"
                v-model="queryParam.isRecovery"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6" :xs="24">
            <a-form-item label="告警时间">
              <a-range-picker
                :placeholder="['开始时间', '结束时间']"
                @change="getList"
                format="YYYY-MM-DD"
                v-model="timeRange1"
                valueFormat="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <a-form-item label="告警信息">
              <a-input allowClear placeholder="告警信息模糊查询" v-debounce="getList" v-model="queryParam.summary"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="6" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="getList" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleExportXls('iot_alert_list')" icon="download" type="primary">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-wrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="alertName" slot-scope="alertName, record">{{ record.devId_dictText || '工艺告警' }}</span>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            @click="previewFile(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="summarySlot" slot-scope="text, record">
          <a-icon
            @click="showReport(record)"
            style="font-size:16px;color:#40a9ff;"
            title="事件报告"
            type="audit"
            v-if="!!record.reportId"
          />
          <span style="margin-left:10px;">{{ text }}</span>
        </span>
        <span slot="levelSlot" slot-scope="text, record">
          <a-tag :color="$filterDictTextByCache('alert_level_color', text)">{{ record.alertLevel_dictText }}</a-tag>
        </span>
        <span slot="isAcknowledgementSlot" slot-scope="isAcknowledgement, record">
          <a-tag color="gray" v-if="record.isAcknowledgement == 0">未确认</a-tag>
          <a-tag color="#52c41a" v-else>已确认</a-tag>
        </span>
        <span slot="recoverySlot" slot-scope="isRecovery, record">
          <a-tag color="#ff4d4f" v-if="record.isRecovery == 0">未恢复</a-tag>
          <a-tag color="#52c41a" v-else>已恢复</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-tooltip title="设备详情">
            <a-icon
              :disabled="!record.devId"
              @click="devDetail(record)"
              style="color: #1890ff;cursor: pointer;"
              type="setting"
            />
          </a-tooltip>

          <a-divider type="vertical" />
          <a-tooltip title="数据曲线">
            <a-icon
              :disabled="!record.pointCode"
              @click="dataLine(record)"
              style="color: #1890ff;cursor: pointer;"
              type="line-chart"
            />
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="告警日志">
            <a-icon
              :disabled="!record.pointCode"
              @click="alertLife(record)"
              style="color: #1890ff;cursor: pointer;"
              type="history"
            />
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="事件报告">
            <a-icon
              :disabled="!record.pointCode"
              @click="checkCondition(record)"
              style="color: #1890ff;cursor: pointer;"
              type="file-done"
            />
          </a-tooltip>
          <a-divider type="vertical" />
          <a-tooltip title="加入白名单">
            <a-icon
              :disabled="record.alertType != 1"
              @click="handleWhiteModal(record)"
              style="color: #1890ff;cursor: pointer;"
              type="eye-invisible"
            />
          </a-tooltip>
        </span>
      </a-table>
    </div>
    <points-line-chart-modal ref="pointsDataLineModal"></points-line-chart-modal>
    <alert-life-cycle-modal ref="alertLifeModal"></alert-life-cycle-modal>
    <iot-alert-whitelist-modal ref="whiteModalForm"></iot-alert-whitelist-modal>
    <iot-model-event-report-modal ref="modelEventReport"></iot-model-event-report-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PointsLineChartModal from '@views/monitor/datas/modules/PointsLineChartModal'
  import AlertLifeCycleModal from './modules/AlertLifeCycleModal'
  import moment from 'dayjs'
  import { getAction } from '@/api/manage'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { queryWhiteListByGroupCode } from '@/utils/h-request'
  import IotAlertWhitelistModal from '@views/alert/modules/IotAlertWhitelistModal'
  import IotModelEventReportModal from './modules/IotModelEventReportModal.vue'

  export default {
    name: 'IotAlertHistory',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      PointsLineChartModal,
      IotAlertWhitelistModal,
      AlertLifeCycleModal,
      IotModelEventReportModal
    },
    data () {
      const forceNowrap = text => <span class="j-force-nowrap">{text}</span>
      return {
        description: '告警历史',
        // 表头
        columns: [
          {
            title: '告警名称',
            align: 'center',
            width: 180,
            scopedSlots: { customRender: 'alertName' }
          },
          {
            title: '告警时间',
            align: 'center',
            dataIndex: 'alertTime',
            width: 150,
            customRender: forceNowrap
          },
          {
            title: '告警信息',
            align: 'center',
            dataIndex: 'summary',
            align: 'left',
            scopedSlots: { customRender: 'summarySlot' }
          },
          {
            title: '告警等级',
            align: 'center',
            dataIndex: 'alertLevel',
            width: 100,
            scopedSlots: { customRender: 'levelSlot' }
          },
          {
            title: '是否确认',
            align: 'center',
            width: 100,
            dataIndex: 'isAcknowledgement',
            scopedSlots: { customRender: 'isAcknowledgementSlot' }
          },
          {
            title: '是否恢复',
            align: 'center',
            width: 100,
            dataIndex: 'isRecovery_dictText',
            scopedSlots: { customRender: 'recoverySlot' }
          },
          {
            title: '附件',
            align: 'center',
            width: 120,
            dataIndex: 'attachment',
            scopedSlots: { customRender: 'imgSlot' },
            sorter: true
          },
          {
            title: '处理方式',
            align: 'center',
            width: 100,
            dataIndex: 'disposal_dictText',
            customRender: forceNowrap
          },
          {
            title: '告警分类',
            align: 'center',
            width: 100,
            dataIndex: 'alertType_dictText',
            customRender: forceNowrap
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 160,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/alert/iotAlert/list',
          delete: '/alert/iotAlert/delete',
          deleteBatch: '/alert/iotAlert/deleteBatch',
          exportXlsUrl: '/alert/iotAlert/exportXls',
          importExcelUrl: 'alert/iotAlert/importExcel'
        },
        dictOptions: {},
        superFieldList: [],
        timeRange1: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      getList () {
        if (validatenull(this.timeRange1)) {
          this.queryParam.startTime = ''
          this.queryParam.endTime = ''
        } else {
          this.queryParam.startTime = this.timeRange1[0] + ' 00:00:00'
          this.queryParam.endTime = this.timeRange1[1] + ' 23:59:59'
        }
        console.log(this.queryParam)
        this.searchQuery()
      },
      async handleWhiteModal (record) {
        if (record.ruleGroupId) {
          const response = await queryWhiteListByGroupCode({
            groupCode: record.ruleGroupId,
            alertRecoverTime_begin: moment().format('YYYY-MM-DD HH:mm:ss')
          })
          if (response.success && response.result.records.length > 0) {
            return this.$message.warning('该告警已存在白名单')
          }
        }
        this.$refs.whiteModalForm.add(record)
        this.$refs.whiteModalForm.title = '加入白名单'
        this.$refs.whiteModalForm.disableSubmit = false
      },
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams() // 查询条件
        if (params.summary) {
          params.summary = `*${params.summary}*`
        }
        this.loading = true
        getAction(this.url.list, params)
          .then(res => {
            if (res.success) {
              this.dataSource = res.result.records || res.result
              if (res.result.total) {
                this.ipagination.total = res.result.total
              } else {
                this.ipagination.total = 0
              }
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'int', value: 'groupId', text: '小组编号' })
        fieldList.push({ type: 'int', value: 'alertGroupId', text: '预警分组编号' })
        fieldList.push({ type: 'string', value: 'groupName', text: '小组名称' })
        fieldList.push({ type: 'string', value: 'alertName', text: '告警名称' })
        fieldList.push({ type: 'string', value: 'ruleId', text: '规则id' })
        fieldList.push({ type: 'string', value: 'pointCode', text: '测点点号' })
        fieldList.push({ type: 'string', value: 'devId', text: '传感器Sn码' })
        fieldList.push({ type: 'string', value: 'processId', text: '供水流域id' })
        fieldList.push({ type: 'date', value: 'alertTime', text: '告警时间' })
        fieldList.push({ type: 'string', value: 'summary', text: '告警信息' })
        fieldList.push({ type: 'int', value: 'alertType', text: '告警分类(测点采集、视频识别、音频识别)' })
        fieldList.push({ type: 'string', value: 'attachment', text: '附件文件id（图片、视频、音频等）' })
        fieldList.push({ type: 'int', value: 'alertLevel', text: '预警等级' })
        fieldList.push({ type: 'int', value: 'isAcknowledgement;', text: '是否被处理' })
        fieldList.push({ type: 'int', value: 'disposal', text: '处理方式' })
        fieldList.push({ type: 'int', value: 'isRecovery', text: '是否恢复' })
        this.superFieldList = fieldList
      },
      toOtherPage (route) {
        this.$router.push({
          path: route
        })
      },
      dataLine (record) {
        const timeRange = [
          moment(record.alertTime)
            .add(-1, 'hours')
            .format('YYYY-MM-DD HH:mm'),
          moment(record.alertTime)
            .add(1, 'hours')
            .format('YYYY-MM-DD HH:mm')
        ]
        const pointCode = record.pointCode
        const alertTime = record.alertTime

        let marks
        if (record.alertValue) {
          marks = {
            markPoints: {},
            markLines: {}
          }
          const alertValArr = record.alertValue.split(';')
          for (let index = alertValArr.length - 1; index >= 0; index--) {
            const valStr = alertValArr[index]

            if (!valStr.includes('{')) {
              return
            }
            const color =
              filterDictTextByCache('alert_level_color', parseInt(record.alertLevel) + alertValArr.length - 1 - index) ||
              'red'
            const valueMap = JSON.parse(valStr)
            const xAxis = valueMap.time
            const pointVals = JSON.parse(valueMap.value)

            const markLine = {
              name: '告警时刻',
              xAxis: xAxis,
              itemStyle: {
                color: color
              },
              lineStyle: {
                type: 'solid'
              },
              label: {
                //  label属性 设置图线的样式
                show: false
              }
            }
            for (const pointCode in pointVals) {
              if (Object.hasOwnProperty.call(pointVals, pointCode)) {
                const pVal = pointVals[pointCode]

                const markPoint = {
                  name: '告警时刻',
                  yAxis: pVal,
                  xAxis: xAxis,
                  value: pVal,
                  itemStyle: {
                    color: color
                  }
                }
                marks.markPoints[pointCode]
                  ? marks.markPoints[pointCode].push(markPoint)
                  : (marks.markPoints[pointCode] = [markPoint])
                marks.markLines[pointCode]
                  ? marks.markLines[pointCode].push(markLine)
                  : (marks.markLines[pointCode] = [markLine])
              }
            }
          }
        }
        this.$refs.pointsDataLineModal.show(pointCode, timeRange, alertTime, 'noValue', marks)
      },
      devDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.devId,
          type: 'drawer'
        })
      },
      alertLife (record) {
        this.$refs.alertLifeModal.show(record)
      },
      checkCondition (record) {
        this.$refs.modelEventReport.disableSubmit = false
        this.$refs.modelEventReport.edit(record)
      },
      showReport (record) {
        this.$refs.modelEventReport.title = '事件报告'
        this.$refs.modelEventReport.disableSubmit = true
        this.$refs.modelEventReport.edit(record)
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
